import { useLocation } from 'react-router-dom';
import { getSiteBySlug } from '../sites/registry';

/* Site-wide attribution, owned by the app instead of a fixed overlay in index.html,
   so each layout decides where it sits. Wording unchanged pending owner review. */
export const ATTRIBUTION_TEXT = 'Agent9 is an AI real estate assistant powered by AsterPOS Corp.';

// Layouts that render the attribution inline, in their own footer.
const INLINE_PATHS = new Set(['/']);

const FLOATING_STYLE = {
  display: 'inline-flex', boxSizing: 'border-box', padding: '6px 12px', alignItems: 'center', gap: 6,
  borderRadius: 50, background: 'rgba(15, 23, 42, 0.85)', border: '1px solid rgba(100, 116, 139, 0.2)',
  position: 'fixed', bottom: 12, right: 12, zIndex: 9999, backdropFilter: 'blur(8px)',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
};
const TEXT_STYLE = { color: 'rgba(148, 163, 184, 0.7)', fontSize: 10, fontStyle: 'normal', fontWeight: 400, lineHeight: '14px', margin: 0, whiteSpace: 'nowrap' };

/** Floating badge, identical to the previous index.html markup. Use inside the router. */
export function FloatingAttribution({ alwaysShow = false }) {
  const { pathname } = useLocation();
  if (!alwaysShow && INLINE_PATHS.has(pathname)) return null;
  // The Tele Sale portal is not a real estate product, so the RE wording stays off it.
  if (!alwaysShow && pathname.startsWith('/telesales')) return null;
  // A hosted customer site that is not real estate (e.g. a security firm) opts out.
  const m = pathname.match(/^\/sites\/([^/]+)/);
  if (m && getSiteBySlug(m[1])?.hide_attribution) return null;
  return (
    <div style={FLOATING_STYLE} data-testid="site-attribution-floating">
      <p style={TEXT_STYLE}>{ATTRIBUTION_TEXT}</p>
    </div>
  );
}
